module.exports = __webpack_public_path__ + "media/american-kestrel-2.f3b959dc.mp3";